module.exports = __webpack_public_path__ + "img/ancient_of_life_small.3fd247d7.png";